import React from 'react';
import Contenidoshub from '../components/mainpages/contenidoshub/Contenidohub';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const ContenidosView = () => {
    return (
        <>
        {/*<Link to={'./vamosaprobar'} >ruta para probar</Link>*/}
            {/*<Contenidoshub />*/}
            Not 
        </>
    );
}

export default ContenidosView;